import { groupBy } from 'lodash';
import {
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '@reverbdotcom/commons/src/gql/graphql';

const EXPRESS_PAYMENT_METHODS = new Set([
  CheckoutPaymentMethodType.PAYPAL_PAY_LATER,
  CheckoutPaymentMethodType.DC_VIA_PAYPAL,
  CheckoutPaymentMethodType.APPLE_PAY,
  CheckoutPaymentMethodType.ANDROID_PAY,
]);

type PaymentMethodGroup<PaymentMethod> = Record<'express' | 'standard', PaymentMethod[]>;

interface AcceptedPaymentMethod {
  type?: CheckoutPaymentMethodType;
}

export function groupedPaymentMethods<PaymentMethod extends AcceptedPaymentMethod>(
  paymentMethods: PaymentMethod[],
  standalonePayPalExp: boolean = false,
): PaymentMethodGroup<PaymentMethod> {
  const groups = groupBy(paymentMethods, (paymentMethod) => {
    if (EXPRESS_PAYMENT_METHODS.has(paymentMethod.type)) {
      return 'express';
    }

    return 'standard';
  });

  if (standalonePayPalExp) {
    return {
      express: paymentMethods,
      standard: paymentMethods,
    };
  }

  return {
    express: groups.express || [],
    standard: groups.standard || [],
  };
}
